import { z } from 'zod'
import {
  CommunicationType,
  ScaleBaudrate,
  ScaleParity,
  ScaleDataBits,
  type PeripheralScaleSettings
} from '../../models/PeripheralSettings'
import { CommandType } from '../../models/PeripheralManufacturer'

const ScaleConfigDTO = z.object({
  baudrate: z.nativeEnum(ScaleBaudrate).nullish(),
  parity: z.nativeEnum(ScaleParity).nullish(),
  serial_port_converter: z.boolean().nullish(),
  databits: z.nativeEnum(ScaleDataBits).nullish()
})

export const PeripheralScaleSettingsDTO = z.object({
  address: z.string().nullish(),
  port: z.number().nullish(),
  printer_model: z.string().nullish(),
  communication_type: z.nativeEnum(CommunicationType).nullish(),
  command_type: z.nativeEnum(CommandType).nullish(),
  scale: ScaleConfigDTO.nullish()
})

export type PeripheralScaleSettingsDTO = z.infer<typeof PeripheralScaleSettingsDTO>

export function mapPeripheralScaleSettingsToDTO (model: PeripheralScaleSettings): PeripheralScaleSettingsDTO {
  return {
    address: model.address,
    port: model.port,
    printer_model: model.model,
    communication_type: model.communicationType,
    command_type: model.commandType,
    scale: model.scale
      ? {
          baudrate: model.scale.baudrate,
          parity: model.scale.parity,
          serial_port_converter: model.scale.serialPortConverter,
          databits: model.scale.databits
        }
      : undefined
  }
}

export function mapDTOToPeripheralScaleSettings (dto: PeripheralScaleSettingsDTO): PeripheralScaleSettings {
  return {
    address: dto.address ?? undefined,
    port: dto.port ?? undefined,
    model: dto.printer_model ?? undefined,
    communicationType: dto.communication_type ?? undefined,
    commandType: dto.command_type ?? undefined,
    scale: dto.scale
      ? {
          baudrate: dto.scale.baudrate ?? undefined,
          parity: dto.scale.parity ?? undefined,
          serialPortConverter: dto.scale.serial_port_converter ?? undefined,
          databits: dto.scale.databits ?? undefined
        }
      : undefined
  }
}
